import Cookies from 'universal-cookie';
import { CookieChecker } from './CookieChecker';
var CookieHelper = /** @class */ (function () {
    function CookieHelper() {
        this.cookies = new Cookies();
    }
    CookieHelper.getInstance = function () {
        if (!CookieHelper.instance) {
            CookieHelper.instance = new CookieHelper();
        }
        return CookieHelper.instance;
    };
    CookieHelper.prototype.set = function (name, value, maxAge) {
        var options = maxAge ? { path: '/', maxAge: maxAge } : { path: '/' };
        this.cookies.set(name, value, options);
    };
    CookieHelper.prototype.get = function (name) {
        return this.cookies.get(name);
    };
    /**
     * This function will listen for when a specified cookie gets set and call the onCookieSet function
     * @param listenCookie a function for specifying which cookie there should listen for change in
     * @param onCookieSet a function for what should happen when the given cookie has been set
     */
    CookieHelper.prototype.listenCookieSet = function (listenCookie, onCookieSet) {
        var cookieChecker = new CookieChecker(listenCookie, onCookieSet);
        cookieChecker.run();
    };
    return CookieHelper;
}());
export { CookieHelper };
